import { styled } from '@workday/canvas-kit-react-common';
export var ButtonLabel = styled('span')({
    position: 'relative',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
});
